L.Toolbar2.EditAction.Control.New = L.Toolbar2.EditAction.fromHandler(
    L.EditToolbar.New,
    {
        className: 'leaflet-draw-edit-new',
        tooltip: 'Add features'
    },
    new L.Toolbar2({
        actions: [
            L.Toolbar2.EditAction.Control.Save,
            L.Toolbar2.EditAction.Control.Undo
        ]
    })
);
